/**
 * 企微聊天侧边栏的登录与 JS-SDK 签名（顾问陪跑 PR⑦）。
 * 授权与登录走公网 authClient（还没有会话）；签名走需登录的 apiClient。
 */
import { apiClient, authClient } from './client';

interface ServiceResponse<T> {
  code: number;
  message: string;
  data: T;
  requestId: string;
}

export interface JssdkSignature {
  timestamp: number;
  nonceStr: string;
  signature: string;
}

export interface WecomJssdkConfig {
  corpId: string;
  agentId: string;
  config: JssdkSignature;
  agentConfig: JssdkSignature;
}

export async function getWecomAuthorizeUrl(redirectUri: string, state: string) {
  const resp = await authClient.get<ServiceResponse<{ url: string }>>('/auth/wechat-scan/wecom/authorize-url', {
    params: { redirectUri, state },
  });
  return resp.data.data.url;
}

export async function loginWithWecomCode(code: string) {
  const resp = await authClient.post<
    ServiceResponse<{ accessToken: string; refreshToken: string; actorId: string; role: string; expiresIn: number }>
  >('/auth/wechat-scan/wecom', { code });
  return resp.data.data;
}

export async function getWecomJssdkConfig(url: string) {
  const resp = await apiClient.get<ServiceResponse<WecomJssdkConfig>>('/wecom/jssdk-config', { params: { url } });
  return resp.data.data;
}
